var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121.37 151.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d7006c;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke:#ba458c;stroke-miterlimit:10;}.cls-4{fill:#161615;}.cls-5{fill:#ca247c;}.cls-6{fill:#c9257c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    className: "cls-1",
    d: "M119.93,27.26a29.92,29.92,0,0,0-8.11-15.11,50.14,50.14,0,0,0-8.44-6.79,25.06,25.06,0,0,0-34.57,7.77c-.4.62-.76,1.26-1.09,1.9L61.81,26.41a.32.32,0,0,1-.56,0L54.58,13.56A25.07,25.07,0,0,0,20.81,2.8c-.65.34-1.28.7-1.9,1.09A50.27,50.27,0,0,0,4.43,18l0,.07C-18.88,72.77,57.75,146.24,62.73,150.94a.31.31,0,0,0,.43,0l0,0,39.24-61.13c4.62-7.38,24.39-29.19,17.5-62.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    className: "cls-2",
    d: "M60.34,40.43A28.19,28.19,0,1,1,32.15,12.24,28.19,28.19,0,0,1,60.34,40.43h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    className: "cls-3",
    d: "M60.34,40.43A28.19,28.19,0,1,1,32.15,12.24,28.19,28.19,0,0,1,60.34,40.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    className: "cls-4",
    d: "M50.16,39.79A19.47,19.47,0,1,1,30.69,20.33,19.47,19.47,0,0,1,50.16,39.79h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    className: "cls-2",
    d: "M33.47,30a9.24,9.24,0,1,1-9.24-9.24A9.24,9.24,0,0,1,33.47,30h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    className: "cls-5",
    d: "M9.27,68.21c.87-1,10.4,5.37,25.71,5.07,7.46-.15,12.3-1.78,12.85-.9.71,1.14-6.06,5.87-14.1,6.56C20.17,80.11,8.23,69.35,9.27,68.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    className: "cls-2",
    d: "M118,40.43A28.19,28.19,0,1,1,89.86,12.24,28.18,28.18,0,0,1,118,40.43h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    className: "cls-3",
    d: "M118,40.43A28.19,28.19,0,1,1,89.86,12.24,28.18,28.18,0,0,1,118,40.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    className: "cls-4",
    d: "M107.87,39.79A19.47,19.47,0,1,1,88.4,20.33a19.47,19.47,0,0,1,19.47,19.46h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    className: "cls-2",
    d: "M91.17,30a9.24,9.24,0,1,1-9.24-9.24A9.24,9.24,0,0,1,91.17,30h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    className: "cls-6",
    d: "M67,68.21c.87-1,10.4,5.37,25.71,5.07,7.46-.15,12.3-1.78,12.86-.9.71,1.14-6.07,5.87-14.1,6.56C77.87,80.11,65.93,69.35,67,68.21"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon6.c5d88aa3d3471b4c60abac1ad4762394.svg";
export { ForwardRef as ReactComponent };